import { render, staticRenderFns } from "./CardTotalSONeedApprove.vue?vue&type=template&id=40dda857"
import script from "./CardTotalSONeedApprove.vue?vue&type=script&lang=js"
export * from "./CardTotalSONeedApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports